import { SelectItemType } from '../../components/Select/Select';

type FindLanguageParams = {
  language: string;
  languageData: SelectItemType[] | null;
};

export const languageUtils = {
  getLanguageRegularExpression() {
    return new RegExp(CONFIG.locales
      .map(lang => `^/${lang.slice(0, 2)}/`).join('|'));
  },
  getPathWithSlashInTheEnd(path: string | null) {
    return path?.endsWith('/') ? path : `${path}/`;
  },
  getDefaultLanguage() {
    return CONFIG.defaultLocale.slice(0, 2);
  },
  getCountryCode() {
    return CONFIG.defaultLocale.slice(3).toUpperCase();
  },
  getLanguageCode(language?: string) {
    if (!language) {
      return CONFIG.defaultLocale.slice(0, 2);
    }
    return language.slice(0, 2);
  },
  getFullLanguageCodeByLangCode(langCode: string) {
    const langWithoutSlashes = langCode.replace(/\//g, '');
    const language = CONFIG.locales.find(lang => lang.startsWith(langWithoutSlashes));

    return language || CONFIG.defaultLocale;
  },
  findLanguage({
    languageData,
    language,
  }: FindLanguageParams) {
    return languageData?.find(el => el.id.toLowerCase() === language);
  },
};
